import { isNil } from 'lodash'
import { createStore } from 'zustand'

import { queryListingApi } from '@eastcoal/api/trade/listingMall/queryListing'

import { ListingPickerStore } from './interface'

export const createListingPickerStore = () =>
  createStore<ListingPickerStore>((set, get) => ({
    pickerListing: undefined,
    modalOpen: false,
    listingDetail: undefined,
    setPickerListing(value) {
      set({ pickerListing: value })
    },
    deletePickerListing() {
      set({ pickerListing: undefined, listingDetail: undefined })
    },
    toggleModalOpen() {
      const visible = get().modalOpen
      set({ modalOpen: !visible })
    },
    async setListingDetail() {
      const pickerListing = get().pickerListing

      if (isNil(pickerListing)) {
        set({ listingDetail: undefined })
      }

      const listingDetail = await queryListingApi(
        { id: pickerListing?.id },
        { silence: true }
      )

      set({ listingDetail })
    }
  }))
